import * as React from "react";
import { useState, useEffect } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { dropdownService } from "../../services/api/dropdown.service";
import { nomService } from "../../services/api/nom.service";
import { partnerService } from '../../services/api/partner.service';
import { useNavigate } from 'react-router-dom';

export const PartnerList = (props) => {


    const navigate = useNavigate();

    const [rol, setRol] = useState(3);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(30);
    const [rowClicked, setRowClicked] = useState(null);
    const [searchText, setSearchText] = useState(""); // Adăugăm starea pentru textul căutat


    useEffect(() => {
        nomService.getRole().then(response => { setRol(response) });
    }, [rol]);

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setCurrentPage(1); // Resetăm pagina când utilizatorul introduce text nou pentru a afișa rezultatele filtrate de la pagina 1
    };

    const [data, setData] = useState([]);

    const paginate = (pageNumber) => {
        setRowClicked(null);
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;

    // Filtrăm lista în funcție de textul căutat
    const filteredItems = data.filter((item) =>
       item.text.toLowerCase().includes(searchText.toLowerCase())
    );

    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelect = (item) => {
        if (item && item.id >= 0) {

            partnerService.getLocations({ partener: item.id })
                .then(response => {
                    if (response && response.length > 0) {
                        sessionStorage.setItem('haveLocations', true);
                    }
                    else {
                        sessionStorage.setItem('haveLocations', false);
                    }

                });

            partnerService.getLocationsSpecialCons({ partener: item.id })
                .then(response => {
                    if (response && response.length > 0) {
                        sessionStorage.setItem('haveLocationsSpecialCons', true);
                    }
                    else {
                        sessionStorage.setItem('haveLocationsSpecialCons', false);
                    }
                });

            sessionStorage.setItem('idPartener', item.id);
            sessionStorage.setItem('numePartener', item.text);
            if (rol != 2) {
                navigate('/dashboard/cautare-pacient');
            }
            else {
                navigate('/dashboard/cautare/');
            }
        }
    };

    useEffect(() => {
        dropdownService.getPartners().then(response => {
            if (response) {
                setData(response);
            }

        });
    }, [])

    return (
        <>
            <div className="list-items">
                {currentItems.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => setRowClicked(index)}
                        onDoubleClick={() => handleSelect(item)}
                        className={
                            rowClicked !== null && rowClicked === index
                                ? "dwgrid_sel"
                                : ""
                        }
                    >
                        <span>{(currentPage - 1) * perPage + index + 1} </span>{" "}
                        <span>{item.text}</span>
                    </div>
                ))}
            </div>

            <div className="w400 ">
                {/* Adăugăm evenimentul de schimbare a căutării */}
                <Input
                    name="search"
                    placeholder="Caută"
                    className="fl w300"
                    value={searchText}
                    onChange={handleSearchChange}
                />
                <Button icon="search" themeColor={"primary"} className="">
                    Cauta
                </Button>
            </div>

            <div className="mt20">
                <div className="w70 fl mt5">
                    <span className="">
                        {(currentPage - 1) * perPage + 1}{" "}
                    </span>{" "}
                    - <span> {Math.min(currentPage * perPage, filteredItems.length)}</span>
                </div>
                <div className="fl">
                    <button
                        className="pagination-button"
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                    >
                        |&lt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        &lt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={
                            currentPage ===
                            Math.ceil(filteredItems.length / perPage)
                        }
                    >
                        &gt;
                    </button>
                    <button
                        className="pagination-button"
                        onClick={() =>
                            paginate(
                                Math.ceil(filteredItems.length / perPage)
                            )
                        }
                        disabled={
                            currentPage ===
                            Math.ceil(filteredItems.length / perPage)
                        }
                    >
                        &gt;|
                    </button>
                </div>
            </div>

        </>
    );
};
